import './Icon.scss';

const Icon = ({
	name, className, onClick, children, isHM, label, position, hasHover
}) => {
	const iconClass = isHM ? 'HMIcons' : 'Icon';
	return (
		<div className={`icon ${hasHover ? 'hasHover' : ''}`}>
			<span onClick={onClick} className={`${iconClass} ${iconClass}_${name} ${className}`} role="button" tabIndex={-1}>
				{children}
			</span>
			{ label && (
				<div className={`icon-title ${position || ''}`}>{label}</div>
			)}
		</div>
	);
};

Icon.propTypes = {
	name: PropTypes.string.isRequired,
	className: PropTypes.string,
	onClick: PropTypes.func,
	children: PropTypes.node,
	isHM: PropTypes.bool,
	hasHover: PropTypes.bool,
	label: PropTypes.string,
	position: PropTypes.string
};

Icon.defaultProps = {
	className: '',
	hasHover: false,
	onClick: null,
	children: null,
	isHM: false,
	label: null,
	position: null
};

export default Icon;
